import { Icons, SpinnerLoading } from '@cockpitai/components/atoms'
import useDebounce from '@cockpitai/hooks/useDebounce'
import { useEffect, useState } from 'react'
import { twMerge } from 'tailwind-merge'
import { tv } from 'tailwind-variants'

const historyInputTV = tv({
  slots: {
    container: 'px-2 flex items-center',
    containerIcon:
      'bg-black/20 flex items-center justify-center w-10 px-2 h-10 rounded-l-lg',
    input:
      'h-10 w-full flex-shrink pl-1 !rounded-l-none rounded-lg bg-black/20 text-base leading-6 tracking-wider text-white/50 outline-none pr-3',
  },
})

export function HistoryInput({
  onSearch,
  isChat = false,
  isLoading = false,
  isOpen = true,
}: {
  onSearch(text: string): void
  isChat?: boolean
  isLoading?: boolean
  isOpen?: boolean
}) {
  const [text, setText] = useState('')

  useDebounce(() => onSearch(text), 250, [text])

  useEffect(() => {
    if (!isOpen) {
      setText('')

      onSearch('')
    }
  }, [isOpen, onSearch])

  const { container, containerIcon, input } = historyInputTV()

  return (
    <div className={twMerge('absolute top-0 z-10 w-full', container())}>
      <div className={containerIcon()}>
        {isLoading ? (
          <SpinnerLoading />
        ) : (
          <Icons.Search className="text-white/50" />
        )}
      </div>
      <input
        type="search"
        value={text}
        placeholder={isChat ? 'Pesquise nas suas conversas' : 'Pesquisar'}
        onChange={(e) => setText(e.target.value)}
        className={input()}
      />
    </div>
  )
}
